import { Menu, MenuButton, MenuItem, MenuItems, Transition } from "@headlessui/react";
import { Fragment } from "react";
import classNames from "classnames";
import HelpCircleIcon from "@icons/help-circle.svg?react";
import { useTour } from "@providers/TourProvider";
import { NAV_ICON_BUTTON_CLASS, NAV_ICON_CLASS } from "./navIconButton";

export default function HelpMenu() {
    const { helpMenuTours, startTour, getTourState } = useTour();

    return (
        <Menu as="div" className="relative inline-block text-left">
            <MenuButton
                className={NAV_ICON_BUTTON_CLASS}
                data-tour="help-menu"
                title="Product tours"
                aria-label="Help menu"
            >
                <HelpCircleIcon className={NAV_ICON_CLASS} />
            </MenuButton>
            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <MenuItems
                    modal={false}
                    className="absolute right-0 mt-2 w-[300px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
                >
                    <div className="px-3 pt-3 pb-1">
                        <div className="text-md font-bold text-gray-900">Explore HappyDoc</div>
                        <div className="text-sm text-gray-400 mt-0.5">Interactive walkthroughs</div>
                    </div>
                    <div className="mx-3 h-px bg-gray-100" />
                    <div className="p-1">
                        {helpMenuTours.map((tour) => {
                            const state = getTourState(tour.id);
                            const isCompleted = state?.status === "completed";

                            return (
                                <MenuItem key={tour.id}>
                                    {({ focus }) => (
                                        <button
                                            onClick={() => startTour(tour.id)}
                                            className={`${
                                                focus ? "bg-max-900 text-white" : isCompleted ? "bg-slate-100" : ""
                                            } group flex w-full items-center gap-2.5 rounded-md px-2 py-2.5 transition-colors`}
                                        >
                                            {/* Status circle */}
                                            {isCompleted ? (
                                                <div
                                                    className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 ${
                                                        focus ? "bg-white/25" : "bg-max-900"
                                                    }`}
                                                >
                                                    <svg className="w-[11px] h-[11px]" viewBox="0 0 20 20" fill="white">
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                            clipRule="evenodd"
                                                        />
                                                    </svg>
                                                </div>
                                            ) : (
                                                <div
                                                    className={`w-5 h-5 rounded-full border-[1.5px] flex-shrink-0 ${
                                                        focus ? "border-white/50" : "border-gray-300"
                                                    }`}
                                                />
                                            )}

                                            {/* Text content */}
                                            <div className="flex-1 min-w-0 text-left">
                                                <div
                                                    className={`text-sm font-medium ${
                                                        focus
                                                            ? "text-white"
                                                            : isCompleted
                                                              ? "text-gray-500"
                                                              : "text-gray-700"
                                                    }`}
                                                >
                                                    {tour.name}
                                                </div>
                                                <div
                                                    className={`text-xs leading-snug mt-0.5 ${
                                                        focus ? "text-white" : "text-gray-400"
                                                    }`}
                                                >
                                                    {tour.description}
                                                </div>
                                            </div>

                                            {/* Action label */}
                                            <span
                                                className={classNames(
                                                    "text-xs font-semibold flex-shrink-0",
                                                    focus
                                                        ? isCompleted
                                                            ? "text-white/80"
                                                            : "text-white"
                                                        : isCompleted
                                                          ? "text-gray-500"
                                                          : "text-max-900",
                                                )}
                                            >
                                                {isCompleted ? "Replay" : "Start"}
                                            </span>
                                        </button>
                                    )}
                                </MenuItem>
                            );
                        })}
                    </div>
                </MenuItems>
            </Transition>
        </Menu>
    );
}
